(function () {
  'use strict';

  // ─── CARRUSEL (una instancia por subcategoría) ──────────────────────────
  function initAuroraCarousel(carouselEl) {
    const key = carouselEl.dataset.auroraCarousel;
    const track = carouselEl.querySelector('[data-aurora-track]');
    const prevBtn = carouselEl.querySelector(`[data-aurora-prev="${key}"]`);
    const nextBtn = carouselEl.querySelector(`[data-aurora-next="${key}"]`);
    const slides = Array.from(track.querySelectorAll('.aurora__carousel__slide'));

    if (!slides.length) return null;

    let current = 0;

    function visibleCount() {
      const w = track.parentElement.offsetWidth;
      const sw = slides[0].offsetWidth + 12;
      return Math.max(1, Math.floor(w / sw));
    }

    function update() {
      const sw = slides[0].offsetWidth + 12;
      track.style.transform = `translateX(-${current * sw}px)`;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= slides.length - visibleCount();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { current = Math.max(0, current - 1); update(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { current = Math.min(slides.length - visibleCount(), current + 1); update(); });

    update();
    return { update };
  }

  function initAuroraCarousels(dropdown) {
    dropdown.querySelectorAll('[data-aurora-carousel]').forEach(carouselEl => {
      const api = initAuroraCarousel(carouselEl);
      if (api) carouselEl._auroraCarousel = api;
    });
  }

  // ─── HOVER CATEGORÍA IZQUIERDA → cambia subpanel central Y carrusel derecho ─
  function initAuroraHover(dropdown) {
    const cats = dropdown.querySelectorAll('.aurora__cat[data-aurora-cat]');
    if (!cats.length) return;

    const centerEl = dropdown.querySelector('[data-aurora-center]');
    const rightWrapper = dropdown.querySelector('[data-aurora-right-wrapper]');

    const allPanels = centerEl ? Array.from(centerEl.querySelectorAll('.aurora__subpanel')) : [];
    const allRightPanels = rightWrapper ? Array.from(rightWrapper.querySelectorAll('[data-aurora-right-panel]')) : [];

    cats.forEach((cat) => {
      cat.addEventListener('mouseenter', () => {
        cats.forEach(c => c.classList.remove('aurora__cat--active'));
        cat.classList.add('aurora__cat--active');

        const idx = parseInt(cat.dataset.auroraCat, 10) - 1;

        allPanels.forEach(p => p.classList.remove('aurora__subpanel--active'));
        if (allPanels[idx]) {
          allPanels[idx].classList.add('aurora__subpanel--active');
        }

        allRightPanels.forEach(p => p.classList.remove('aurora__carousel-panel--active'));
        if (allRightPanels[idx]) {
          allRightPanels[idx].classList.add('aurora__carousel-panel--active');
          const carouselEl = allRightPanels[idx].querySelector('[data-aurora-carousel]');
          if (carouselEl && carouselEl._auroraCarousel) {
            carouselEl._auroraCarousel.update();
          }
        }
      });
    });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.header__dropdown--aurora').forEach(dropdown => {
      initAuroraCarousels(dropdown);
      initAuroraHover(dropdown);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();